<template>
  <!-- Productos -->
  <section id="products" class="bg-white">
    <div class="text-black relative bg-white">
      <div class=" border-t border-b border-gray-200 sticky top-16 lg:top-[92px] py-1 sm:py-2 bg-white">
        <section class="flex gap-1 lg:gap-6 px-1 lg:px-4 z-40 max-w-screen-xl mx-auto justify-center items-end">
        <button
          v-for="category in categories"
          :key="category.id"
          :id="category.id"
          class="border-2 border-transparent hover:border-white hover:bg-black/15 rounded-md overflow-hidden text-center bg-white relative"
          :class="'category-' + category.id === selectedCategory  ? 'bg-slate-50/15': ''"
          @click="scrollToCategory(category.id)">
          <img :src="category.image" :alt="category.name" class="object-cover" 
            style="width: 100px; height: 100px;"/>
          <h3 class="font-light text-lg sm:font-bold absolute bottom-0 text-white inset-x-0 bg-gradient-to-b from-transparent to-black/50 pt-10">
            {{ category.name }}
          </h3>
        </button>
        </section>
      </div>
      
      <section id="productsContainer" class="max-w-screen-xl mx-auto">
        <category v-for="category in categories" :key="category.id" :global="global" :category="category" />
      </section>
      
    </div>
  </section>

  <cart :cart="cart"></cart>
</template>

<script>
import Category from "./category.vue";
import Voucher from "./voucher.vue";

import { cart } from "../cart"

export default {
  components: { Category, Voucher },
  props: {
    categories: {
      type: Object,
      required: true
    },
    global: {
      type: Object,
      required: true
    },
    props: ["active"]
  },
  computed: {
    filteredCategories() {
      return this.categories.filter(category => category.name.includes(this.query));
    },
  },
  data() {
    return {
      ready: false,
      query: "",
      showForm: false,
      selectedCategory: "",
      threshold: 0,
    };
  },
  mounted() {
    this.ready = true;

    this.getThreshold();
    this.observeCategories();
  },
  methods: {
    observeCategories() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= this.getThreshold()) {
            this.selectedCategory = entry.target.id;
          }
        });
      }, {
        threshold: this.getThreshold(),
      });

      this.categories.forEach(category => {
        observer.observe(document.getElementById('category-'+category.id));
      });
    },
    scrollToTop() {
      const container = this.$refs.productContainer;
      if (container) {
        container.scrollIntoView({
          behavior: 'smooth', 
          block: 'start', 
        });
      }
    },
    scrollToCategory(categoryId) {
      this.$nextTick(() => {
        const categoryElement = document.getElementById(`category-${categoryId}`);
        if (categoryElement) {
          categoryElement.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start', 
          });
        }
      });
    },
    handleShowForm(){
      this.showForm = true
      // scroll to form
      this.$nextTick(() => {
        const formulary = document.getElementById('form');
        if (formulary) {
          formulary.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start', 
          });
        }
      });
    },
    getThreshold() {
      if(innerWidth < 768){
        return 0.8
      } else {
        return 0.5
      }
    }
  },
};
</script>


